export default __webpack_public_path__ + "static/media/single-assets.2f13ac6a.svg";